import { Entity } from 'src/app/core/data/schema/entity';
import { DateTime } from 'luxon';

export enum SupportStatus {
    New = 0,
    Assigned = 1,
    Closed = 2
}
export enum SupportProduct
{
    CommuniBee = 1,
    BidBeacon = 2,
    RaffleRocket = 3
}

export class SupportRequest extends Entity{

    static className = 'SupportRequest';
    static idField = 'supportRequestId';
    
    supportRequestId: number = 0;
    parentId: number;
    userId: number;
    source: string;
    targetProduct: number;

    userEmail: string;
    subject: string;
    body: string;
    attachmentUrls: string;
    
    priority: number;
    status: number = SupportStatus.New;
    guid: string;

    timestamp: string;
    assignedUserId: number;
    communityId: number;

    escalatedOn: string;
    deletedOn: string;

    assignedName: boolean;
    communityName: boolean;

    replies: SupportRequest[];
    files: any[];
  
    timestampObj: DateTime;
    escelatedOnObj: DateTime;

    // parsed for display
    attachmentPaths: string[] = [];
    statusString: string;
    productName: string

    constructor(sponsorship?: Partial<SupportRequest>) {
        super('SupportRequest', 'supportRequestId', 'Support');
        Object.assign(this, sponsorship);

        this.statusString = SupportStatus[this.status];
        this.productName = SupportProduct[this.targetProduct];

        if (this.attachmentUrls != null ) {
            this.attachmentPaths = this.attachmentUrls.split(',');
        }
        if (this.timestamp != null ) {
            this.timestampObj = DateTime.fromISO(this.timestamp, { zone: 'utc' });
        } 
        if (this.escalatedOn != null ) {
            this.escelatedOnObj = DateTime.fromISO(this.escalatedOn, { zone: 'utc' });
        } 
        if ( this.replies != null) {
            this.replies = this.replies.map(m => new SupportRequest(m));
        }
    }

    matchesProduct(selected: string){
        
        if ( selected == 'all products' ){
            return true; //['draft', 'upcoming', 'live'].includes(this.eventState.toLowerCase());
        }
        return selected == this.productName.toLowerCase()
    }
    
    matchesStatus(selected: string){
        
        if ( selected == 'all' ){
            return true; //['draft', 'upcoming', 'live'].includes(this.eventState.toLowerCase());
        }
        return selected == this.statusString.toLowerCase()
    }

    // ----------------------------------------------------
    // Service-like features from here on down
    // ----------------------------------------------------
    public static async load(id: number) {
        return await SupportRequest.getById(SupportRequest, id, 'support');
    }
    public static async loadByGuid(guid: string) {
        return await SupportRequest.getObject(SupportRequest, 'support', 'forGuid/' + guid);
    }

    public static async fetchForCurrCommunity() {
        return await SupportRequest.fetchArray(SupportRequest, 'support', `forCommunity`);
    }

    public static async fetchForLaunch() {
        return await SupportRequest.fetchArray(SupportRequest, 'support', `l57tickets`);
    }
    
}
